<template>
  <modal @modal-close="handleClose">
    <form
      class="bg-white rounded-lg shadow-lg overflow-hidden"
      style="width: 460px"
      @submit.prevent="handleUpgrade"
    >
      <div class="p-8">
        <div v-if="Object.keys(message).length" class="text-center text-80 leading-normal ">
          <p v-if="message.limit" class="font-semibold text-xl">{{ message.limit + '/' + message.limit }}</p>
          <p v-if="message.text">{{ message.text }}</p>
          <p v-if="message.advice">{{ message.advice }}</p>
        </div>
      </div>

      <div class="bg-30 px-6 py-3 flex">
        <div class="ml-auto">
          <button
            type="button"
            class="btn text-80 font-normal h-9 px-3 mr-3 btn-link"
            @click.prevent="handleClose"
          >
            {{ $t('Cancel') }}
          </button>
          <button
            id="upgrade"
            ref="confirmButton"
            class="btn btn-default btn-primary"
            @click.prevent="handleUpgrade"
          >
            {{ $t('Upgrade') }}
          </button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
  export default {
    props: {
      message: {
        type: Object,
        default: () => {},
      },
    },
    mounted() {
      this.$refs.confirmButton.focus();
    },
    methods: {
      handleClose() {
        this.$emit('close');
      },
      handleUpgrade() {
        this.$router.push({ name: 'subscribe' });
      },
    },
  };
</script>
